import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.product ? _c('div', {
    staticClass: "configurador-item"
  }, [_c('fieldset', {
    staticClass: "configurador-fields",
    attrs: {
      "disabled": _vm.locked
    }
  }, [_c('div', {
    staticClass: "configurador-resumo"
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.product.descricao))]), _vm.showFinancial ? _c('small', {
    staticClass: "d-block text-muted"
  }, [_vm._v(" A partir de " + _vm._s(_vm.formatMoney(_vm.product.preco)) + " ")]) : _vm._e()]), _vm._m(0)]), _vm.combos.length && !_vm.compositionItem ? _c('section', {
    staticClass: "configurador-secao"
  }, [_c('h6', [_vm._v("Combo")]), _c('div', {
    staticClass: "configurador-opcoes"
  }, _vm._l(_vm.combos, function (combo) {
    return _c('label', {
      key: combo.id,
      staticClass: "configurador-opcao",
      class: {
        'is-selected': _vm.selectedComboId === combo.id
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.selectedComboId,
        expression: "selectedComboId"
      }],
      attrs: {
        "type": "radio",
        "name": "restaurant-combo-".concat(_vm._uid)
      },
      domProps: {
        "value": combo.id,
        "checked": _vm._q(_vm.selectedComboId, combo.id)
      },
      on: {
        "change": [function ($event) {
          _vm.selectedComboId = combo.id;
        }, _vm.resetComboConfiguration]
      }
    }), _c('span', [_c('strong', [_vm._v(_vm._s(combo.nome))]), _vm.showFinancial ? _c('small', [_vm._v(_vm._s(_vm.formatMoney(combo.preco_combo)))]) : _vm._e()])]);
  }), 0)]) : _vm._e(), _vm.pizza ? _c('section', {
    staticClass: "configurador-secao"
  }, [_c('h6', [_vm._v("Tamanho")]), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v(" " + _vm._s(_vm.fixedSize ? "Tamanho definido no combo." : "Escolha o tamanho antes dos sabores.") + " ")]), _c('div', {
    staticClass: "configurador-opcoes"
  }, _vm._l(_vm.pizzaSizes, function (size) {
    return _c('label', {
      key: _vm.sizeKey(size),
      staticClass: "configurador-opcao",
      class: {
        'is-selected': _vm.selectedSize === _vm.sizeKey(size)
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.selectedSize,
        expression: "selectedSize"
      }],
      attrs: {
        "type": "radio",
        "name": "restaurant-item-size-".concat(_vm._uid),
        "disabled": Boolean(_vm.fixedSize)
      },
      domProps: {
        "value": _vm.sizeKey(size),
        "checked": _vm._q(_vm.selectedSize, _vm.sizeKey(size))
      },
      on: {
        "change": [function ($event) {
          _vm.selectedSize = _vm.sizeKey(size);
        }, _vm.trimPizzaFlavors]
      }
    }), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.optionName(size)))]), _vm.showFinancial && !_vm.selectedCombo && _vm.optionPriceCents(size) ? _c('small', [_vm._v(" " + _vm._s(_vm.formatMoney(_vm.optionPriceCents(size) / 100)) + " ")]) : _vm._e()])]);
  }), 0), _vm.selectedSizeObject ? [_c('h6', {
    staticClass: "mt-5"
  }, [_vm._v("Sabores")]), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v(" Escolha de 1 a " + _vm._s(_vm.maxPizzaFlavors) + " " + _vm._s(_vm.maxPizzaFlavors === 1 ? "sabor" : "sabores") + ". ")]), !_vm.compositionItem ? _c('p', {
    staticClass: "configurador-regra-preco"
  }, [_vm._v(" O valor considera o tamanho e somente o maior acréscimo entre os sabores escolhidos. ")]) : _vm._e(), _c('div', {
    staticClass: "configurador-opcoes"
  }, _vm._l(_vm.availablePizzaFlavors, function (flavor) {
    return _c('label', {
      key: _vm.optionKey(flavor),
      staticClass: "configurador-opcao",
      class: {
        'is-selected': _vm.isFlavorSelected(flavor)
      }
    }, [_c('input', {
      attrs: {
        "type": "checkbox",
        "disabled": !_vm.isFlavorSelected(flavor) && _vm.selectedFlavors.length >= _vm.maxPizzaFlavors
      },
      domProps: {
        "checked": _vm.isFlavorSelected(flavor)
      },
      on: {
        "change": function change($event) {
          return _vm.toggleFlavor(flavor);
        }
      }
    }), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.optionName(flavor)))]), _vm.showFinancial && _vm.flavorPriceCents(flavor) ? _c('small', [_vm._v(" + " + _vm._s(_vm.formatMoney(_vm.flavorPriceCents(flavor) / 100)) + " ")]) : _vm._e()])]);
  }), 0), _vm.availablePizzaBorders.length ? [_c('h6', {
    staticClass: "mt-5"
  }, [_vm._v("Borda")]), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Opcional.")]), _c('div', {
    staticClass: "configurador-opcoes"
  }, [_c('label', {
    staticClass: "configurador-opcao",
    class: {
      'is-selected': !_vm.selectedBorder
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.selectedBorder,
      expression: "selectedBorder"
    }],
    attrs: {
      "type": "radio",
      "name": "restaurant-item-border-".concat(_vm._uid)
    },
    domProps: {
      "value": null,
      "checked": _vm._q(_vm.selectedBorder, null)
    },
    on: {
      "change": function change($event) {
        _vm.selectedBorder = null;
      }
    }
  }), _vm._m(1)]), _vm._l(_vm.availablePizzaBorders, function (border) {
    return _c('label', {
      key: _vm.optionKey(border),
      staticClass: "configurador-opcao",
      class: {
        'is-selected': _vm.selectedBorder === _vm.optionKey(border)
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.selectedBorder,
        expression: "selectedBorder"
      }],
      attrs: {
        "type": "radio",
        "name": "restaurant-item-border-".concat(_vm._uid)
      },
      domProps: {
        "value": _vm.optionKey(border),
        "checked": _vm._q(_vm.selectedBorder, _vm.optionKey(border))
      },
      on: {
        "change": function change($event) {
          _vm.selectedBorder = _vm.optionKey(border);
        }
      }
    }), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.optionName(border)))]), _vm.showFinancial && _vm.optionPriceCents(border) ? _c('small', [_vm._v(" + " + _vm._s(_vm.formatMoney(_vm.optionPriceCents(border) / 100)) + " ")]) : _vm._e()])]);
  })], 2)] : _vm._e()] : _vm._e()], 2) : _vm._e(), _vm._l(_vm.optionGroups, function (group) {
    return _c('section', {
      key: _vm.groupKey(group),
      staticClass: "configurador-secao"
    }, [_c('div', {
      staticClass: "configurador-secao-titulo"
    }, [_c('div', [_c('h6', [_vm._v(_vm._s(_vm.groupName(group)))]), _c('p', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(_vm.groupRule(group)))])]), _vm.groupRequired(group) ? _c('span', {
      staticClass: "badge badge-light-danger"
    }, [_vm._v(" Obrigatório ")]) : _vm._e()]), _vm.isTextGroup(group) ? _c('b-form-textarea', {
      attrs: {
        "id": "restaurant-option-".concat(_vm._uid, "-").concat(_vm.groupKey(group)),
        "aria-label": _vm.groupName(group),
        "value": _vm.selection(group),
        "rows": "2",
        "maxlength": _vm.groupMaxLength(group),
        "placeholder": group.placeholder || 'Digite a preferência do cliente'
      },
      on: {
        "input": function input($event) {
          return _vm.setTextSelection(group, $event);
        }
      }
    }) : _c('div', {
      staticClass: "configurador-opcoes"
    }, [_vm.isSingleGroup(group) && !_vm.groupRequired(group) ? _c('div', {
      staticClass: "configurador-opcao-wrap",
      class: {
        'is-selected': !_vm.selection(group)
      }
    }, [_c('label', {
      staticClass: "configurador-opcao"
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "name": "restaurant-option-".concat(_vm._uid, "-").concat(_vm.groupKey(group))
      },
      domProps: {
        "checked": !_vm.selection(group)
      },
      on: {
        "change": function change($event) {
          return _vm.clearOptionSelection(group);
        }
      }
    }), _c('span', [_c('strong', [_vm._v("Sem opção")])])])]) : _vm._e(), _vm._l(_vm.groupOptions(group), function (option) {
      return _c('div', {
        key: _vm.optionKey(option),
        staticClass: "configurador-opcao-wrap",
        class: {
          'is-selected': _vm.isOptionSelected(group, option)
        }
      }, [_c('label', {
        staticClass: "configurador-opcao"
      }, [_c('input', {
        attrs: {
          "type": _vm.isSingleGroup(group) ? 'radio' : 'checkbox',
          "name": "restaurant-option-".concat(_vm._uid, "-").concat(_vm.groupKey(group)),
          "disabled": _vm.isOptionDisabled(group, option)
        },
        domProps: {
          "checked": _vm.isOptionSelected(group, option)
        },
        on: {
          "change": function change($event) {
            return _vm.toggleOption(group, option);
          }
        }
      }), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.optionName(option)))]), _vm.showFinancial && _vm.optionPriceCents(option) ? _c('small', [_vm._v(" + " + _vm._s(_vm.formatMoney(_vm.optionPriceCents(option) / 100)) + " ")]) : _vm._e()])]), _vm.groupAllowsQuantity(group) && _vm.isOptionSelected(group, option) ? _c('div', {
        staticClass: "configurador-adicional-quantidade",
        attrs: {
          "aria-label": "Quantidade de ".concat(_vm.optionName(option))
        }
      }, [_c('button', {
        staticClass: "btn btn-light",
        attrs: {
          "type": "button",
          "aria-label": "Diminuir ".concat(_vm.optionName(option)),
          "disabled": _vm.optionQuantity(group, option) <= 1
        },
        on: {
          "click": function click($event) {
            return _vm.changeOptionQuantity(group, option, -1);
          }
        }
      }, [_c('i', {
        staticClass: "fas fa-minus",
        attrs: {
          "aria-hidden": "true"
        }
      })]), _c('strong', [_vm._v(_vm._s(_vm.optionQuantity(group, option)))]), _c('button', {
        staticClass: "btn btn-light",
        attrs: {
          "type": "button",
          "aria-label": "Aumentar ".concat(_vm.optionName(option)),
          "disabled": !_vm.canIncreaseOptionQuantity(group, option)
        },
        on: {
          "click": function click($event) {
            return _vm.changeOptionQuantity(group, option, 1);
          }
        }
      }, [_c('i', {
        staticClass: "fas fa-plus",
        attrs: {
          "aria-hidden": "true"
        }
      })])]) : _vm._e()]);
    })], 2)], 1);
  }), _vm.comboItems.length ? _c('section', {
    staticClass: "configurador-secao"
  }, [_c('h6', [_vm._v("Itens incluídos no combo")]), _vm._l(_vm.comboItems, function (item) {
    return _c('div', {
      key: "".concat(_vm.selectedComboId, ":").concat(item.chave),
      staticClass: "configurador-combo-item"
    }, [_c('h6', [_vm._v(" " + _vm._s(item.quantidade || 1) + " × " + _vm._s(item.nome || item.produto_nome || item.produto_slug) + " ")]), item.produto ? _c('ConfiguradorItemRestaurante', {
      ref: "comboConfigurators",
      refInFor: true,
      attrs: {
        "product": _vm.comboItemProducts[item.chave],
        "composition-item": item,
        "locked": _vm.locked,
        "show-financial": false
      }
    }) : _c('p', {
      staticClass: "text-danger"
    }, [_vm._v(" Este item do combo está indisponível. ")])], 1);
  })], 2) : _vm._e(), !_vm.compositionItem ? _c('section', {
    staticClass: "configurador-secao configurador-finalizacao"
  }, [_c('div', {
    staticClass: "configurador-campo"
  }, [_c('label', {
    attrs: {
      "for": "restaurant-item-quantity"
    }
  }, [_vm._v("Quantidade")]), _c('div', {
    staticClass: "configurador-quantidade"
  }, [_c('button', {
    staticClass: "btn btn-light",
    attrs: {
      "type": "button",
      "aria-label": "Diminuir quantidade",
      "disabled": _vm.quantity <= 1
    },
    on: {
      "click": function click($event) {
        _vm.quantity -= 1;
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-minus",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('b-form-input', {
    attrs: {
      "id": "restaurant-item-quantity",
      "type": "number",
      "min": "1",
      "max": "99"
    },
    model: {
      value: _vm.quantity,
      callback: function callback($$v) {
        _vm.quantity = _vm._n($$v);
      },
      expression: "quantity"
    }
  }), _c('button', {
    staticClass: "btn btn-light",
    attrs: {
      "type": "button",
      "aria-label": "Aumentar quantidade",
      "disabled": _vm.quantity >= 99
    },
    on: {
      "click": function click($event) {
        _vm.quantity += 1;
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)])]) : _vm._e(), !_vm.compositionItem ? _c('div', {
    staticClass: "configurador-campo mt-4"
  }, [_c('label', {
    attrs: {
      "for": "restaurant-item-observation"
    }
  }, [_vm._v("Observação do item")]), _c('b-form-textarea', {
    attrs: {
      "id": "restaurant-item-observation",
      "rows": "2",
      "maxlength": "500",
      "placeholder": "Ex.: sem cebola, servir molho à parte"
    },
    model: {
      value: _vm.observation,
      callback: function callback($$v) {
        _vm.observation = typeof $$v === 'string' ? $$v.trim() : $$v;
      },
      expression: "observation"
    }
  })], 1) : _vm._e(), _vm.errors.length ? _c('div', {
    staticClass: "alert alert-light-danger mt-4 mb-0",
    attrs: {
      "role": "alert",
      "aria-live": "assertive"
    }
  }, [_c('strong', [_vm._v("Revise a configuração:")]), _c('ul', {
    staticClass: "mb-0 mt-2 pl-5"
  }, _vm._l(_vm.errors, function (error, index) {
    return _c('li', {
      key: index
    }, [_vm._v(_vm._s(error))]);
  }), 0)]) : _vm._e()], 2), _vm.quote ? _c('div', {
    staticClass: "configurador-cotacao",
    attrs: {
      "role": "status",
      "aria-live": "polite"
    }
  }, [_vm._m(2), _c('strong', [_vm._v(_vm._s(_vm.formatMoney(_vm.quoteTotalCents / 100)))])]) : _vm._e()]) : _vm._e();
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    staticClass: "configurador-seguranca"
  }, [_c('i', {
    staticClass: "fas fa-shield-alt",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Valor conferido pelo sistema ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', [_c('strong', [_vm._v("Sem borda")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('span', [_vm._v("Total calculado pelo sistema")]), _c('small', [_vm._v("A configuração fica bloqueada até confirmar ou recalcular.")])]);
}];
export { render, staticRenderFns };